import { fetchPageAssets } from '../../ducks/hostedAssets.duck';

export const ASSET_NAME = 'contact';

export const loadData = () => dispatch => {
  const pageAsset = { contact: `content/pages/${ASSET_NAME}.json` };
  return dispatch(fetchPageAssets(pageAsset, true));
};
